'use client';

import dynamic from 'next/dynamic';
import { useEffect } from 'react';

import { Container } from '@/app/components/layouts/container';
import { SubMenuBaseGrid } from '@/app/components/layouts/top-navigation/sub-menu/base/grid';
import type { NavMenuItemType } from '@/app/types/top-navigation';
import { safeCall } from '@/app/utils/safeCall';

const SubMenuBaseExpand = dynamic(
  () =>
    import('@/app/components/layouts/top-navigation/sub-menu/base/expand').then(
      (mod) => mod.SubMenuBaseExpand
    ),
  {
    ssr: false,
  }
);

export type SubMenuBaseRenderOptions = 'grid' | 'expand';
interface SubMenuBaseProps {
  as?: SubMenuBaseRenderOptions;
  items?: NavMenuItemType[];
  isModelBuyingTools?: boolean;
  isDesktop?: boolean;
  onReady?: () => void;
  onClose?: () => void;
}

export const SubMenuBase = ({
  items = [],
  as = 'grid',
  isModelBuyingTools = false,
  isDesktop = false,
  onReady,
  onClose,
}: SubMenuBaseProps) => {
  useEffect(() => {
    safeCall(onReady);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (items.length === 0) return null;

  const content =
    as === 'grid' ? (
      <SubMenuBaseGrid
        items={items}
        isModelBuyingTools={isModelBuyingTools}
        isDesktop={isDesktop}
        onClose={onClose}
      />
    ) : (
      <SubMenuBaseExpand items={items} isDesktop={isDesktop} />
    );

  return (
    <Container
      size="desktop-only"
      className="grid w-full grid-cols-1 py-6 md:py-10 xl:grid-cols-12 xl:gap-x-6 xl:gap-y-8 xl:py-0"
    >
      {content}
    </Container>
  );
};
